// Debounce
// https://redd.one/blog/debounce-vs-throttle
// If function is called several times in {duration},
// wait for a pause longer than {duration} to actually trigger it.
// eg, wait 500 milliseconds after last call to actually call doSomething():
// debounce(function () {
//    doSomething();
//  }, 500)
function debounce(func, duration) {
	let timeout;
	return function (...args) {
		const effect = () => {
			timeout = null;
			return func.apply(this, args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(effect, duration);
	};
}

function mmCartSectionIdLong() {
	return document.querySelector('.mm-cart').id;
}

function mmCartSectionId() {
	return document.querySelector('.mm-cart').id.replace('shopify-section-', '');
}

function mmCartSectionElement() {
	return document.getElementById(`${mmCartSectionIdLong()}`);
}

function mmCartProductsContainerElement() {
	return mmCartSectionElement().querySelector('.mm-dc-products-container');
}

function mmCartItem(productVariantId) {
	return mmCartProductsContainerElement().querySelector(`[data-cart-item-variant-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
	const itemEl = mmCartItem(productVariantId);

	return itemEl.querySelector('[data-item-quantity]');
}

function mmGetCartItemQuantity(productVariantId) {
	const quantityEl = mmCartItemQuantityEl(productVariantId);

	return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
	if (newQuantity >= 0) {
		const quantityEl = mmCartItemQuantityEl(productVariantId);

		quantityEl.dataset.itemQuantity = newQuantity;
		quantityEl.innerText = newQuantity;
	}
}

function mmCartHTMLFromData(data) {
	const el = document.createElement('DIV');
	el.innerHTML = data.sections['mm-cart-items'];

	return el;
}

function extractItemsFromCartHTML(data) {
	const el = mmCartHTMLFromData(data);
	return el.querySelector('.mm-dc-products-container');
}

function insertCartProductsFromResponse(data) {
	const itemsContainer = extractItemsFromCartHTML(data);
	mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

	return data;
}

function extractTotalPriceFromCartHTML(data) {
	const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
	return cartEl.querySelector('[data-cart-total-price]');
}

function insertInsertTotalPriceFromResponse(data) {
	const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
	const currentTotalPriceEl = mmCartSectionElement().querySelector('[data-cart-total-price]');
	currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;

	return data;
}

function mmAPIRequest(method, path, body) {
    document.querySelector(".mm-dc-products")?.classList?.add("mm-inactive");
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    })
    .then((response) => response.json())
    .then((data) => {
        document.querySelector(".mm-dc-products")?.classList?.remove("mm-inactive");
        if (data.status && data.status > 400) {
            throw data;
        } else {
            return data;
        }
    })
}

// récupérer le panier
function mmGetCart() {
	return mmAPIRequest('GET', 'cart.js');
}

// Récupérer le nombre de produits dans le panier
function mmUpdateItemsQttyFromApi() {
	return fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: { "Content-Type": "application/json" }
    })
    .then((response) => response.json())
    .then((data) => {
		document.querySelector('.cart-count-bubble').innerText = data.item_count;
    })
}

// Ouvrir le panier
function mmOpenCart() {
	var redirectUrl = '/cart';
	window.location.href = redirectUrl;
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
	const newCartEl = document.createElement('DIV');
	newCartEl.innerHTML = data.sections[mmCartSectionId()];
	const innerCart = mmCartSectionElement().querySelector('.mm-cart-container');
	innerCart.innerHTML = newCartEl.querySelector('.mm-cart-container').innerHTML;

	applyStoredTagSelection();
	checkForAvailabilityCount();
	openingHours();
	getNextBusinessDay();

    // CART COUNT
	updateCartCount(newCartEl.querySelector('[data-cart-count]').dataset.cartCount);

	return data;
}

// Ajouter un item au panier
function mmAddProductToCart(productId, { quantity = 1, openCart = true }) {
	// Récupérer le nombre d'items dans le panier AVANT l'ajout
	return mmGetCart().then((cartData) => {
		const wasEmpty = cartData.item_count === 0;

		// Prix saisi en caisse (PV vide) : propriété de ligne indicative affichée au panier/checkout/mail
		const lineProp = document.getElementById('mm-line-prop-prix');
		const item = { quantity: quantity, id: productId };
		if (lineProp && lineProp.value) {
			item.properties = { 'Prix': lineProp.value };
		}

		return mmAPIRequest('POST', 'cart/add.js', {
			items: [item],
		}).catch((error) => {
			console.log(error);
		})
		.then(mmUpdateItemsQttyFromApi)
		.then(() => {
			// Redirection automatique vers le panier uniquement au premier ajout
			if (wasEmpty && openCart) {
				mmOpenCart();
			}
		});
	});
}


// Ajouter un item au panier product card
function mmAddToCartProductCard(productId, { quantity = 1 }) {
    const variantId = productId;

    mmAPIRequest('POST', 'cart/add.js', {
        items: [{ quantity: quantity, id: variantId }],
    })
    .catch((error) => {
        console.log('Erreur lors de l\'ajout au panier : ', error);
    })
    .then(mmUpdateItemsQttyFromApi);
}


function mmIncreaseProductQuantity(productVariantId) {
	const quantity = mmGetCartItemQuantity(productVariantId);
	const newQuantity = quantity + 1;
	mmSetCartItemQuantity(productVariantId, newQuantity);
	mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseProductQuantity(productVariantId) {
	const quantity = mmGetCartItemQuantity(productVariantId);
	const newQuantity = quantity - 1;
	mmSetCartItemQuantity(productVariantId, newQuantity);
	saveAndRemoveUnavailableProducts();
	mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyProductFromCart(productVariantId) {
	const newQuantity = 0;
	mmSetCartItemQuantity(productVariantId, newQuantity);
	saveAndRemoveUnavailableProducts();
	mmDebouncedPushNewQuantity(productVariantId);
}

function mmPushNewQuantity(productVariantId) {
	const quantity = mmGetCartItemQuantity(productVariantId);

	mmAPIRequest('POST', 'cart/change.js', {
		id: productVariantId.toString(),
		quantity: quantity,
		sections: mmCartSectionId(),
	})
    .then(refreshCartFromData);
}

function updateCartCount(value) {
	var cartCountValue = document.querySelector('.cart-count-bubble');
	if (cartCountValue) {
		cartCountValue.innerText = `${value}`;
		console.log("value count", value);
	}
}

function onTagClick(tag) {
	const tags = document.querySelectorAll('.mm-availabilities-wrapper .pickup-availability-preview .mm-cart-pc-store-produit');
	const selectedStoreId = tag.getAttribute('data-store');
	const locationFilterElementInUnavailable = document.querySelector('#unavailable-products .mm-products-header-location-filter');
	const locationAvailabiliy = document.querySelector('.mm-availability-location-filter');
	const locationAvailabiliyMobile = document.querySelector('.mm-availability-location-filter-mobile');
	const availabilityMsgWrapper = document.querySelector('.mm-availabilities-msg-container');
	const availabilityMsgSelectedWrapper = document.querySelector('.mm-availabilities-selected-msg-container');
	const headerWrapper = document.querySelector('.mm-products-header-wrapper');
	const locationFilterElement = document.querySelector('.mm-products-header-location-filter');
	const locationElement = document.querySelector('.mm-availabilities-title-mobile');
	const locationTitleElement = document.querySelector('.mm-availabilities-title-mobile-active-store');
	const locationTitleStoreElement = document.querySelector('.mm-availabilities-mobile-active-store-text');
	const ctaButtons = document.querySelectorAll('.mm-cart-cta');
	const shop_infos = document.querySelectorAll('.mm-cart-help [data-shop-id]');


	if (locationFilterElement) {
		headerWrapper.classList.remove('mm-none');
		availabilityMsgWrapper.classList.add('mm-none');
		availabilityMsgSelectedWrapper.classList.remove('mm-none');
		locationFilterElement.setAttribute('data-location', selectedStoreId);
		locationFilterElement.textContent = tag.textContent;
	}

	if (locationFilterElementInUnavailable) {
		locationFilterElementInUnavailable.setAttribute('data-location', selectedStoreId);
		locationFilterElementInUnavailable.textContent = tag.textContent;
	}

	if (locationAvailabiliy) {
		locationAvailabiliy.setAttribute('data-location', selectedStoreId);
		locationAvailabiliy.textContent = tag.textContent;
	}

	if (locationAvailabiliyMobile) {
		locationAvailabiliyMobile.setAttribute('data-location', selectedStoreId);
		locationAvailabiliyMobile.textContent = tag.textContent;
	}

	if (locationElement) {
		if (locationElement.classList.contains('active')) {
			locationElement.click();
		}
		locationTitleElement.querySelector('.mm-text-xs').classList.remove('mm-none');
		locationTitleStoreElement.setAttribute('data-location', selectedStoreId);
		locationTitleStoreElement.textContent = tag.textContent;
	}

	shop_infos.forEach((shopInfo) => {
		var shop_id = shopInfo.getAttribute('data-shop-id');
		shopInfo.classList.add('mm-none');

		if (selectedStoreId === shop_id) {
			shopInfo.classList.remove('mm-none');
		}
	});

	tags.forEach((otherTag) => {
		if (otherTag !== tag) {
			otherTag.classList.remove('mm-active');
		}
	});

	tag.classList.add('mm-active');
	filterProductsByAvailability(selectedStoreId, tag);
	updateAvailableProductCount();

	ctaButtons.forEach((cta) => {
		if (cta) {
			cta.removeAttribute('disabled');
		}
	});

  // Vérifier les valeurs pour afficher/masquer headerWrapper (si echantillon)
  const availableCountElement = document.querySelector('[data-available-count]');
  const availablePriceElement = document.querySelector('[data-available-price]');

  const availableCount = availableCountElement ? parseInt(availableCountElement.textContent.trim() || '0', 10) : 0;
  const availablePrice = availablePriceElement ? parseFloat(availablePriceElement.textContent.trim().replace(/[^\d.-]/g, '') || '0') : 0;

  if (availableCount === 0 && availablePrice === 0) {
      headerWrapper.classList.add('mm-none');
  } else {
      headerWrapper.classList.remove('mm-none');
  }

	localStorage.setItem('selectedStoreId', selectedStoreId);
	saveAndRemoveUnavailableProducts();
	openingHours();
	getNextBusinessDay();
}

function checkForAvailabilityCount() {
	const tags = document.querySelectorAll('.mm-availabilities-wrapper .pickup-availability-preview .mm-cart-pc-store-produit');
	if (tags.length == 1) {
		tags.forEach((tag) => {
			onTagClick(tag);
		});
	};
}

function filterProductsByAvailability(selectedStoreId, tag) {
	const products = document.querySelectorAll('.mm-cart-pc-container');
	const unavailableProductsContainer = document.getElementById('unavailable-products');
	const productsWrapper = document.querySelector('.mm-products-wrapper');
	const headerTitle = unavailableProductsContainer.querySelector('.mm-products-header-title');

	Array.from(unavailableProductsContainer.children).forEach((child) => {
		if (child !== headerTitle) {
			child.remove();
		}
	});

	products.forEach((product) => {

        // IGNORE les produits Echantillon
        const productType = product.getAttribute('data-product-type');
        if (productType && productType.toLowerCase().includes('echantillon')) {
            return; // Skip ce produit
        }

		const productStoreElements = product.querySelectorAll('.pickup-availability-preview');
		const productLocationWrapper = product.querySelector('.mm-cart-pc-unavailable-location-wrapper');
		const productLocation = product.querySelector('.mm-cart-pc-unavailable-location');
		let storeIdMatch = false;

		productStoreElements.forEach((element) => {
			const productQtty = product.querySelector('.mm-cart-pc-qqty-number');
			const productQttyAttribute = productQtty.getAttribute('data-item-quantity');
			const productStores = element.getAttribute('data-store');
			const productStocks = element.getAttribute('data-stock');
			const addQttyWrappers = product.querySelectorAll('.mm-cart-pc-qqty-wrapper');

			if (productStores.includes(selectedStoreId)) {
				storeIdMatch = true;
				let quantity = parseInt(productQttyAttribute);
				let stocks = parseInt(productStocks);

				addQttyWrappers.forEach((wrapper) => {
					if (quantity > stocks) {
						// Si la quantité actuelle dépasse le stock, ajustez la quantité et désactivez le bouton
						let productVariantId = product.getAttribute('data-cart-item-variant-id');
						mmSetCartItemQuantity(productVariantId, stocks);
						mmDebouncedPushNewQuantity(productVariantId);
						wrapper.querySelector('.mm-cart-pc-qqty-plus').setAttribute('disabled', 'disabled');
					} else if (quantity === stocks) {
						// Si la quantité actuelle égale le stock, juste désactiver le bouton
						wrapper.querySelector('.mm-cart-pc-qqty-plus').setAttribute('disabled', 'disabled');
					} else {
						// Sinon, assurez-vous que le bouton est activé
						wrapper.querySelector('.mm-cart-pc-qqty-plus').removeAttribute('disabled');
					}
				});
			}
		});

		product.style.opacity = storeIdMatch ? '1' : '.5';
		product.classList.remove('mm-available', 'mm-unavailable');
		product.classList.add(storeIdMatch ? 'mm-available' : 'mm-unavailable');

		const unavailableProductsContainer = document.getElementById('unavailable-products');

		if (storeIdMatch) {
			productsWrapper.appendChild(product);
			unavailableProductsContainer.classList.remove('mm-none');
			productLocationWrapper.classList.add('mm-none');
		} else {
			productLocationWrapper.classList.remove('mm-none');
			productLocation.setAttribute('data-selected-store-id', selectedStoreId);
			productLocation.textContent = tag.textContent;
			headerTitle.insertAdjacentElement('afterend', product);
		}

		if (unavailableProductsContainer.children.length === 1) { // Si seulement le headerTitle est présent
			headerTitle.style.display = 'none'; // Cachez le titre si aucun produit n'est disponible
		} else {
			headerTitle.style.display = ''; // Assurez-vous que le titre est visible si des produits sont présents
		}
	});
}

function updateAvailableProductCount() {
	const availableProducts = document.querySelectorAll('.mm-cart-pc-container.mm-available');
	const unAvailableProducts = document.querySelectorAll('.mm-cart-pc-container.mm-unavailable');
	const availableCountElements = document.querySelectorAll('[data-available-count]');
	const unAvailableCountElements = document.querySelectorAll('[data-unavailable-count]');
	const cartCountElements = document.querySelector('[data-cart-count]');
	const availablePriceElements = document.querySelectorAll('[data-available-price]');

	let totalQuantity = 0;
	let totalQuantityUnAvailable = 0;
	let totalPrice = 0;

	availableProducts.forEach((product) => {
		var qttySelector = product.querySelector('.mm-cart-pc-qqty-number');
		var priceSelector = product.querySelector('.mm-cart-pc-price');
		const productType = product.getAttribute('data-product-type');
		const itemQuantity = parseInt(qttySelector.getAttribute('data-item-quantity'));
		const itemPrice = parseFloat(priceSelector.getAttribute('data-item-price'));

		// Ignore les échantillons
		if (productType && productType.toLowerCase().includes('echantillon')) {
			return;
		}

		if (!isNaN(itemQuantity) && !isNaN(itemPrice)) {
			totalQuantity += itemQuantity;
			totalPrice += itemQuantity * itemPrice;
		}
	});

	unAvailableProducts.forEach((product) => {
		var qttySelectorUnAvailable = product.querySelector('.mm-cart-pc-qqty-number');
		const itemQuantityUnAvailable = parseInt(qttySelectorUnAvailable.getAttribute('data-item-quantity'));

		if (!isNaN(itemQuantityUnAvailable)) {
			totalQuantityUnAvailable += itemQuantityUnAvailable;
		}
	});

	availableCountElements.forEach((element) => {
		element.setAttribute('data-available-count', totalQuantity);
		cartCountElements.setAttribute('data-cart-count', totalQuantity);
		element.textContent = totalQuantity + ' ';

		if (parseInt(element.textContent) <= 1) {
			document.querySelector('.mm-available-product-qtty-text-one').classList.remove('mm-none');
			document.querySelector('.mm-available-product-qtty-text-many').classList.add('mm-none');
		} else {
			document.querySelector('.mm-available-product-qtty-text-one').classList.add('mm-none');
			document.querySelector('.mm-available-product-qtty-text-many').classList.remove('mm-none');
		}
	});

	unAvailableCountElements.forEach((element) => {
		element.setAttribute('data-unavailable-count', totalQuantityUnAvailable);
		element.textContent = totalQuantityUnAvailable + ' ';

		if (parseInt(element.textContent) <= 1) {
			document.querySelector('.mm-unavailable-product-qtty-text-one').classList.remove('mm-none');
			document.querySelector('.mm-unavailable-product-qtty-text-many').classList.add('mm-none');
		} else {
			document.querySelector('.mm-unavailable-product-qtty-text-one').classList.add('mm-none');
			document.querySelector('.mm-unavailable-product-qtty-text-many').classList.remove('mm-none');
		}
	});

	availablePriceElements.forEach((element) => {
		const price = totalPrice;
		const euros = price / 100;
		const isWholeNumber = euros % 1 === 0;
		const formattedPrice = euros.toLocaleString('fr-FR', {
			style: 'currency',
			currency: 'EUR',
			minimumFractionDigits: isWholeNumber ? 0 : 2,
			maximumFractionDigits: 2,
		});

		element.setAttribute('data-available-price', price);
		element.textContent = formattedPrice;
	});

	const countTextElements = document.querySelectorAll('.mm-product-list-available-count');
	const countTextElementsHeader = document.querySelectorAll('.mm-product-list-available-count-header');
	const countTextElementsHeaderMobile = document.querySelectorAll('.mm-product-list-available-count-header-mobile');
	const countTextElementsLocation = document.querySelectorAll('.mm-product-list-available-location-header');

	countTextElements.forEach((element) => {
		element.textContent = totalQuantity > 1 ? 'produits' : 'produit';
	});
	countTextElementsHeader.forEach((element) => {
		element.textContent = totalQuantity > 1 ? 'produits sur' : 'produit sur';
	});
	countTextElementsLocation.forEach((element) => {
		element.textContent = totalQuantity > 1 ? 'sont disponibles à' : 'est disponible à';
	});
	countTextElementsHeaderMobile.forEach((element) => {
		element.textContent = totalQuantity > 1 ? 'produits disponibles à' : 'produit disponible à';
	});
}

// function applyStoredTagSelection() {
// 	const storedStoreId = localStorage.getItem('selectedStoreId');
// 	if (storedStoreId) {
// 		const storedTag = document.querySelector(`[data-store="${storedStoreId}"]`);
// 		if (storedTag) {
// 			storedTag.click();
// 		}
// 	}
// }


function applyStoredTagSelection() {
	const storedStoreId = localStorage.getItem('selectedStoreId');
	if (storedStoreId) {
		const storedTag = document.querySelector(`.mm-availabilities-wrapper [data-store="${storedStoreId}"]`);
		if (storedTag) {
			storedTag.click();
			return;
		}
	}
	const firstTag = document.querySelector('.mm-availabilities-wrapper .pickup-availability-preview .mm-cart-pc-store-produit');
	if (firstTag) {
		firstTag.click();
	}
}

function cleanCheckout(event) {
	const checkoutButtons = document.querySelectorAll('.mm-cart-cta');
	const unavailableProductsData = JSON.parse(localStorage.getItem('unavailableProducts'));
	let updates = {};

	checkoutButtons.forEach((checkoutButton) => {
		if (checkoutButton) {
			event.preventDefault();

            if(unavailableProductsData) {
				unavailableProductsData.forEach((productData) => {
					updates[productData.variantId] = 0;
				});
            }

	mmAddOrUpdateProductsInCart(updates, () => {
				mmSetCheckoutPickupLocation(localStorage.getItem('selectedStoreId')).finally(() => {
					window.location.href = checkoutButton.getAttribute('data-url');
				});
			});
		}
	});
}

// Le checkout Shopify présélectionne par défaut le point de retrait le plus proche
// de la géolocalisation IP de l'acheteur : on lui transmet l'entrepôt choisi dans
// le panier via la préférence de livraison du panier (Storefront API, pickupHandle).
// En cas d'échec, on laisse le checkout faire son choix par défaut.
function mmSetCheckoutPickupLocation(locationId) {
	try {
		const features = JSON.parse(document.getElementById('shopify-features')?.textContent || '{}');
		if (!locationId || !features.accessToken) return Promise.resolve();

		return fetch('/cart.js')
			.then((response) => response.json())
			.then((cart) => fetch('/api/2025-07/graphql.json', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Shopify-Storefront-Access-Token': features.accessToken,
				},
				body: JSON.stringify({
					query: `mutation($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
						cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) { userErrors { message } }
					}`,
					variables: {
						cartId: `gid://shopify/Cart/${cart.token}`,
						buyerIdentity: { preferences: { delivery: { deliveryMethod: ['PICK_UP'], pickupHandle: [String(locationId)] } } },
					},
				}),
			}))
			.catch(() => {});
	} catch (e) {
		return Promise.resolve();
	}
}







function checkAndAddeUnavailableProducts() {
	const unavailableProductsData = JSON.parse(localStorage.getItem('unavailableProducts'));
	if (unavailableProductsData && unavailableProductsData.length > 0) {
		let updates = {};

		unavailableProductsData.forEach((productData) => {
			updates[productData.variantId] = parseInt(productData.quantity);
		});
		mmAddOrUpdateProductsInCart(updates, () => {
			// console.log('Produits mis à jour dans le panier');
		});
	}
}

function mmAddOrUpdateProductsInCart(updates, onCompleted) {
	console.log(updates)
	mmAPIRequest('POST', 'cart/update.js', {
		updates: updates,
		sections: mmCartSectionId(),
	})
		.then((data) => {
			refreshCartFromData(data);
			if (onCompleted) {
				onCompleted();
			}
		});
}

function saveAndRemoveUnavailableProducts() {
	const unavailableProducts = Array.from(document.querySelectorAll('#unavailable-products .mm-cart-pc-container'));
	const unavailableProductsData = [];

	unavailableProducts.forEach((product) => {
		const productId = product.getAttribute('data-cart-item-id');
		const variantId = product.getAttribute('data-cart-item-variant-id');
		const productQuantity = product.querySelector('.mm-cart-pc-qqty-number').getAttribute('data-item-quantity');
		unavailableProductsData.push({ productId: productId, variantId: variantId, quantity: productQuantity });
	});
	localStorage.setItem('unavailableProducts', JSON.stringify(unavailableProductsData));
}

function addUnavailableProductToWishlist() {
    // Récupérer les données des produits non disponibles depuis localStorage
    const unavailableProductsData = localStorage.getItem('unavailableProducts');

    // Vérifier si les données existent
    if (unavailableProductsData) {
        // Parser les données JSON pour obtenir l'objet JavaScript
        const products = JSON.parse(unavailableProductsData);

        // Itérer sur chaque produit et les ajouter à la wishlist
        products.forEach((product) => {
            AddToSmartWishlist(product.product_id, product.variant_id);
        });

        // Process wishlist additions after adding them initially
        processWishlistAdditions(products);
        // console.log('Produits ajoutés à la wishlist !');
    } else {
        // console.log('Aucun produit à ajouter à la wishlist.');
    }
}

function processWishlistAdditions(wishlistItems) {
    // Vérifier si la fonction est définie
    if (typeof AddToSmartWishlist !== 'function') {
        console.error('AddToSmartWishlist function is not defined.');
        return;
    }

	// Formatter l'object en tableau
	const formattedWishlistItems = wishlistItems.map(item => [parseInt(item.productId, 10), parseInt(item.variantId, 10)]);

    // Appel de AddToSmartWishlist toutes les secondes
    let index = 0;
    const intervalId = setInterval(() => {
		const [productId, variantId] = formattedWishlistItems[index];
		AddToSmartWishlist(productId, variantId);

		index++;
		if (index >= wishlistItems.length) {
			clearInterval(intervalId);
		}
    }, 100);
}

// Openning hour
function openingHours() {
	var stores = document.querySelectorAll('.mm-cart-modale-shop-open-hour');
	var now = new Date();
	var dayOfWeek = now.getDay(); // Dimanche = 0, Lundi = 1, ..., Samedi = 6
	var hour = now.getHours(); // Heure actuelle

	stores.forEach(function (store) {
		var openTime = store.querySelector('.mm-modale-store-open');
		var closeTime = store.querySelector('.mm-modale-store-close');
		var dot = store.querySelector('.shop-modal-dot');
		if (dayOfWeek >= 1 && dayOfWeek <= 5 && hour >= 10 && hour < 18) {
			store.classList.add('shop-is-open');
			openTime.style.display = 'flex';
			closeTime.style.display = 'none';
			dot.style.background = 'var(--success)';
		} else {
			store.classList.add('shop-is-close');
			openTime.style.display = 'none';
			closeTime.style.display = 'flex';
			dot.style.background = 'var(--primary)';
		}
	});
}

function displayAllopeningHours(event) {
	const shopHour = event.currentTarget;
	const weekHours = shopHour.nextElementSibling;
	shopHour.classList.toggle('active');

	if (weekHours.style.maxHeight) {
		weekHours.style.maxHeight = null;
	} else {
		weekHours.style.maxHeight = weekHours.scrollHeight + 'px';
	}
}

function displayAllLocations(event) {
	const storeLocationsCta = event.currentTarget;
	const storeLocations = storeLocationsCta.nextElementSibling;
	storeLocationsCta.classList.toggle('active');
	storeLocations.classList.toggle('active');

	if (storeLocations.style.maxHeight) {
		storeLocations.style.maxHeight = null;
	} else {
		storeLocations.style.maxHeight = storeLocations.scrollHeight + 'px';
	}
}

function getNextBusinessDay() {
	const months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
	const days = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
	let data = document.getElementById('newFromDate');

	let startDate = new Date(); // Commence à partir d'aujourd'hui

	const businessDaysToAdd = Number(data.getAttribute('rangeDays')); // Nombre de jours ouvrables à ajouter
	let currentDay = startDate;
	let addedDays = 0;

	while (addedDays < businessDaysToAdd) {
		currentDay = new Date(currentDay.getTime() + 24 * 60 * 60 * 1000); // Ajoute un jour
		if (currentDay.getDay() !== 0 && currentDay.getDay() !== 6) {
			// Si ce n'est pas samedi ou dimanche
			addedDays++;
		}
	}

	let deliveryDate = currentDay;
	let insertDates = [...document.querySelectorAll('.shipping-calc__from-date')];

	insertDates.forEach((date) => {
		date.innerHTML = days[deliveryDate.getDay()] + ' ' + deliveryDate.getDate() + ' ' + months[deliveryDate.getMonth()];
	});
}

const mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
	mmPushNewQuantity(productVariantId);
}, 300);

if (window.location.pathname === '/cart') {
	window.addEventListener('DOMContentLoaded', (event) => {
		applyStoredTagSelection();
		checkAndAddeUnavailableProducts();
		checkForAvailabilityCount();
		openingHours();
		getNextBusinessDay();
	});
}

// ---- Limite échantillons (max 4) ----
var MM_SAMPLE_MAX = 4;

function mmAddSampleToCart(variantId) {
	fetch('/cart.js')
		.then(function(r) { return r.json(); })
		.then(function(cartData) {
			var sampleCount = cartData.items.reduce(function(sum, item) {
				if (item.product_type && item.product_type.toLowerCase().includes('echantillon')) {
					return sum + item.quantity;
				}
				return sum;
			}, 0);

			if (sampleCount >= MM_SAMPLE_MAX) {
				mmOpenMaxSamplesModal();
			} else {
				var addBody = { items: [{ quantity: 1, id: variantId }] };
				if (window.location.pathname === '/cart') {
					addBody.sections = mmCartSectionId();
				}

				mmAPIRequest('POST', 'cart/add.js', addBody)
					.then(function(data) {
						if (window.location.pathname === '/cart' && data.sections) {
							refreshCartFromData(data);
						} else {
							mmUpdateItemsQttyFromApi();
						}
						if (typeof mmOpenAddProductPopup === 'function') {
							mmOpenAddProductPopup();
						}
					})
					.catch(function() {
						mmUpdateItemsQttyFromApi();
					});
			}
		})
		.catch(function() {
			mmAddProductToCart(variantId, { openCart: false });
			if (typeof mmOpenAddProductPopup === 'function') {
				mmOpenAddProductPopup();
			}
		});
}

function mmOpenMaxSamplesModal() {
	var modal = document.querySelector('.mm-modal-max-samples');
	if (!modal) return;
	modal.classList.add('mm-modal-is-open');
	document.querySelector('html').classList.add('stop-scrolling');
	setTimeout(function() {
		mmCloseMaxSamplesModal();
	}, 4000);
}

function mmCloseMaxSamplesModal() {
	var modal = document.querySelector('.mm-modal-max-samples');
	if (!modal) return;
	modal.classList.remove('mm-modal-is-open');
	document.querySelector('html').classList.remove('stop-scrolling');
}
